// vendor/marked.min.js は UMD で、esbuild バンドル内では CommonJS と
// 判定されるため window.marked を自分では定義しない。
// markdown_renderer.js がグローバル marked.parse() を参照するので公開する。
import * as marked from "../vendor/marked.min";

window.marked = marked;
